/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { LeaveTimeEntryRequest } from '../models';
import { Request } from '../models';
import { TimeEntryApprovalViewResponse } from '../models';
import { TimeEntryExportViewIEnumerableResponse } from '../models';
import { TimeEntryRequest } from '../models';
import { TimeEntryViewListResponse } from '../models';
import { TimeEntryViewResponse } from '../models';
import { TimesheetRequest } from '../models';
import { TrustTeamMemberTimeEntryFilterRequest } from '../models';
/**
 * TimeEntryApi - axios parameter creator
 * @export
 */
export const TimeEntryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete.');
            }
            const localVarPath = `/api/v1/TimeEntry/DeleteTimeEntry/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost: async (body?: TrustTeamMemberTimeEntryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TimeEntry/ExportTimeEntriesByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showMissingTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntriesPost: async (body?: Request, showMissingTime?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TimeEntry/GetTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (showMissingTime !== undefined) {
                localVarQueryParameter['showMissingTime'] = showMissingTime;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntryApprovalPost: async (body?: TimesheetRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TimeEntry/GetTimeEntryApproval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet.');
            }
            const localVarPath = `/api/v1/TimeEntry/GetTimeEntryById/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntrySaveLeaveTimeEntryPost: async (body?: LeaveTimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TimeEntry/SaveLeaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntrySaveTimeEntryPost: async (body?: TimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/TimeEntry/SaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntryApi - functional programming interface
 * @export
 */
export const TimeEntryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryExportViewIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showMissingTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntryGetTimeEntriesPost(body?: Request, showMissingTime?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewListResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntryGetTimeEntriesPost(body, showMissingTime, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntryGetTimeEntryApprovalPost(body?: TimesheetRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryApprovalViewResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntryGetTimeEntryApprovalPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryViewResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {LeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntrySaveLeaveTimeEntryPost(body?: LeaveTimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntrySaveLeaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TimeEntrySaveTimeEntryPost(body?: TimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV1TimeEntrySaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TimeEntryApi - factory interface
 * @export
 */
export const TimeEntryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any): AxiosPromise<TimeEntryExportViewIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Request} [body] 
         * @param {boolean} [showMissingTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntriesPost(body?: Request, showMissingTime?: boolean, options?: any): AxiosPromise<TimeEntryViewListResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntryGetTimeEntriesPost(body, showMissingTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntryApprovalPost(body?: TimesheetRequest, options?: any): AxiosPromise<TimeEntryApprovalViewResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntryGetTimeEntryApprovalPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): AxiosPromise<TimeEntryViewResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntrySaveLeaveTimeEntryPost(body?: LeaveTimeEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntrySaveLeaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeEntrySaveTimeEntryPost(body?: TimeEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV1TimeEntrySaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntryApi - object-oriented interface
 * @export
 * @class TimeEntryApi
 * @extends {BaseAPI}
 */
export class TimeEntryApi extends BaseAPI {
    /**
     * 
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {TrustTeamMemberTimeEntryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body?: TrustTeamMemberTimeEntryFilterRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntryExportTimeEntriesByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {Request} [body] 
     * @param {boolean} [showMissingTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntryGetTimeEntriesPost(body?: Request, showMissingTime?: boolean, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntryGetTimeEntriesPost(body, showMissingTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {TimesheetRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntryGetTimeEntryApprovalPost(body?: TimesheetRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntryGetTimeEntryApprovalPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {LeaveTimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntrySaveLeaveTimeEntryPost(body?: LeaveTimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntrySaveLeaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {TimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV1TimeEntrySaveTimeEntryPost(body?: TimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV1TimeEntrySaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
